export default "__VITE_ASSET__71YkmVax__"